import React from 'react';
import logoImg from "../assets/images/ntrac-logo.png";
import '../style';



export default class Logo extends React.Component {
    render() {
        return (
          <div className="banner">
            {/* eslint-disable-next-line */}
            {/* <div className="profileIcon">N</div> */}
            <img  className="profileIcon" src={logoImg} alt="Logo"/>
            {this.props.isShowLabel && <div className="label">NTRAC</div>}
          </div>
        );
      }
}


// WEBPACK FOOTER //
// ./src/components/Logo.js